import type { FC } from 'react'

import { SelectableCard } from '@skytech/ui'
import CheckboxBlankCircleOutlineIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'

import { Translation } from '@/app/translations/Translation'
import { numberFormat } from '@/util/formatters/numbers'

const PolicyListTile: FC<{
  id: number
  name: string
  coveredAmount?: number
  selectedPolicyId: number | undefined
  onPolicyClick: (selectedPolicy: number | undefined) => void
}> = ({ id, name, coveredAmount, selectedPolicyId, onPolicyClick }) => {
  const isSelected = selectedPolicyId === id

  const handleClickPolicy = () => {
    if (isSelected) {
      onPolicyClick(undefined)
    } else {
      onPolicyClick(id)
    }
  }

  return (
    <div className="input-wrapper">
      <SelectableCard
        textLeft
        bordered
        padding={16}
        colorMode="yellow"
        className="item"
        isSelected={isSelected}
        onClick={handleClickPolicy}
      >
        <div className="checkmark">
          {isSelected ? <CheckboxMarkedCircleOutlineIcon /> : <CheckboxBlankCircleOutlineIcon />}
        </div>

        <div>
          {name}{' '}
          {coveredAmount && (
            <Translation
              id="{amount} covered"
              className="covered-amount"
              amount={numberFormat(coveredAmount)}
            />
          )}
        </div>
      </SelectableCard>
    </div>
  )
}

export default PolicyListTile
